const MAX_PAYLOAD_SIZE = 102400; // 100 KB (100 * 1024 bytes)

module.exports = { MAX_PAYLOAD_SIZE };
